import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import translate from 'components/hoc/translate';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import ListButton from 'components/button/ListButton';
import ProductMembershipForm from './ProductMembershipForm';
import { createProductMembreship } from 'store/actions/product-memberships/createProductMembership';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

const ProductMembershipsCreate = ({ translate, dispatchForm, history }) => {
    const handleSubmitForm = (values) => {
        return new Promise((resolve) => {
            dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push('/product-memberships'));
                },
                values,
            });
        });
    };

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.product_memberships'),
            link: '/product-memberships',
        },
        {
            label: translate('actions.create'),
        },
    ];

    const initialValues = {
        is_visible: false,
        price_ondemand: null,
        price_scheduled: null,
        supports_ondemand: false,
        supports_scheduled: false,
    };

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('actions.create') } />

                <Actions>
                    <ListButton url='/product-memberships' />
                </Actions>
            </Header>

            <Card>
                <CardText>
                    <ProductMembershipForm
                        form='product-memberships'
                        handleSubmitForm={ handleSubmitForm }
                        initialValues={ initialValues }
                    />
                </CardText>
            </Card>
        </div>
    );
};

ProductMembershipsCreate.propTypes = {
    translate: PropTypes.func.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createProductMembreship(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ProductMembershipsCreate);



// WEBPACK FOOTER //
// ./src/pages/product-memberships/create/ProductMembershipsCreate.js